import React from 'react';
import { MDBFooter, MDBContainer, MDBRow, MDBCol, MDBIcon } from 'mdb-react-ui-kit';
import { faFacebookF, faTwitter, faGoogle, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import history from '../../history';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Footer() {
    return (
        <MDBFooter bgColor='light' className='text-center text-lg-start text-muted mb-5' style={{ paddingBottom: document.documentElement.clientWidth < 1100 ? 100 : 50 }}>
            <section style={{ margin: '20px 0 0', paddingTop: '10px' }}>
                <MDBContainer className='text-center text-md-start'>
                    <MDBRow className='mt-3'>
                        <MDBCol md="3" lg="4" xl="3" className='mx-auto mb-4'>
                            <h6 className='text-uppercase fw-bold mb-4'>
                                SnapWiz
                            </h6>
                            <p>
                                SnapWiz is a platform which connects you with a network of professional photographers and videographers, offering on-demand services tailored to your unique needs.
                            </p>
                        </MDBCol>

                        <MDBCol md="3" lg="2" xl="2" className='mx-auto mb-4'>
                            <h6 className='text-uppercase fw-bold mb-4'>Useful links</h6>
                            <p>
                                <div onClick={() => { history.push("/privacy-policy"); }} className='text-reset' style={{ cursor: 'pointer' }}>
                                    Privacy Policy
                                </div>
                            </p>
                            <p>
                                <div onClick={() => { history.push("/terms"); }} className='text-reset' style={{ cursor: 'pointer' }}>
                                    Terms of Use
                                </div>
                            </p>
                            {/* <p>
                                <div onClick={() => { }} className='text-reset'>
                                    Portfolio
                                </div>
                            </p> */}
                        </MDBCol>

                        <MDBCol md="4" lg="3" xl="3" className='mx-auto mb-md-0 mb-4'>
                            <h6 className='text-uppercase fw-bold mb-4'>Contact</h6>
                            <p>
                                406, 4th Floor, Shiv Darshan Co.op.Society. Dhuswadi, Zaobawadi, Thakurdwar road, Mumbai - 400002.
                            </p>
                            <p>
                                <a href="mailto:contact@snapwiz.in">contact@snapwiz.in</a>
                            </p>
                            <p>
                                <a href="tel:+918828003230">+91 8828003230</a>
                            </p>
                            <p className='mt-4'>
                                {/* <a href='' className='me-4 text-reset'>
                                    <FontAwesomeIcon icon={faFacebookF} style={{ width: 18, height: 18 }} />
                                </a>
                                <a href='' className='me-4 text-reset'>
                                    <FontAwesomeIcon icon={faTwitter} style={{ width: 18, height: 18 }} />
                                </a> */}
                                <a target='_blank' href="mailto:contact@snapwiz.in" className='me-4 text-reset'>
                                    <FontAwesomeIcon icon={faGoogle} style={{ width: 18, height: 18 }} />
                                </a>
                                <a target='_blank' href=' https://www.instagram.com/snapwiz.in' className='me-4 text-reset'>
                                    <FontAwesomeIcon icon={faInstagram} style={{ width: 18, height: 18 }} />
                                </a>
                                <a target='_blank' href='https://www.linkedin.com/in/snapwiz-shah-0a3002370' className='me-4 text-reset'>
                                    <FontAwesomeIcon icon={faLinkedin} style={{ width: 18, height: 18 }} />
                                </a>
                            </p>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>
            </section>

            <div className='text-center p-4' style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
                © {new Date().getFullYear()} Snapwiz. A brand by Shah Eternalgraphers Pvt. Ltd.
            </div>
        </MDBFooter>
    );
}